(function () {
  const mobileQuery = window.matchMedia('(max-width: 1179px)');

  function imageDataFrom(img, source) {
    if (!img) return null;
    return {
      source: source || img,
      src: img.getAttribute('src') || img.currentSrc || '',
      srcset: img.getAttribute('srcset') || '',
      sizes: img.getAttribute('sizes') || '',
      alt: img.getAttribute('alt') || '',
      fullSrc: img.dataset.fullSrc || img.currentSrc || img.getAttribute('src') || ''
    };
  }

  function collectItems(root) {
    const wallpaperSlides = Array.from(root.querySelectorAll('.pp-gallery-main img.pp-slide'));
    if (wallpaperSlides.length) {
      return wallpaperSlides.map((img) => imageDataFrom(img, img)).filter(Boolean);
    }

    return Array.from(root.querySelectorAll('.pp-framed-gallery-panel .product__media-item'))
      .map((item) => imageDataFrom(item.querySelector('img'), item))
      .filter(Boolean);
  }

  function collectThumbs(root) {
    const wallpaperThumbs = Array.from(root.querySelectorAll('[data-pp-mobile-viewer-thumb]'));
    if (wallpaperThumbs.length) return wallpaperThumbs;
    return Array.from(root.querySelectorAll('.pp-framed-gallery-panel .product__media-item'));
  }

  function setupViewer(root) {
    const viewer = root.querySelector('[data-pp-mobile-viewer]');
    const viewerImage = root.querySelector('[data-pp-mobile-viewer-image]');
    if (!viewer || !viewerImage || viewer.dataset.ppMobileViewerReady === 'true') return;

    const items = collectItems(root);
    const thumbs = collectThumbs(root);
    if (!items.length) return;

    viewer.dataset.ppMobileViewerReady = 'true';
    let activeIndex = 0;
    let touchStartX = 0;
    let touchStartY = 0;

    function isViewerActive() {
      return mobileQuery.matches && window.getComputedStyle(viewer).display !== 'none';
    }

    function updateCounter() {
      const current = root.querySelector('[data-pp-mobile-viewer-current]');
      const total = root.querySelector('[data-pp-mobile-viewer-total]');
      if (current) current.textContent = String(activeIndex + 1);
      if (total) total.textContent = String(items.length);
    }

    function updateThumbs() {
      thumbs.forEach((thumb, index) => {
        const isActive = index === activeIndex;
        thumb.classList.toggle('is-active', isActive);
        if (isActive) {
          thumb.setAttribute('aria-current', 'true');
        } else {
          thumb.removeAttribute('aria-current');
        }
      });
    }

    function updateViewer(index, shouldScrollThumb) {
      activeIndex = (index + items.length) % items.length;
      const item = items[activeIndex];

      if (item.srcset) {
        viewerImage.setAttribute('srcset', item.srcset);
      } else {
        viewerImage.removeAttribute('srcset');
      }
      if (item.sizes) viewerImage.setAttribute('sizes', item.sizes);
      viewerImage.src = item.fullSrc || item.src;
      viewerImage.alt = item.alt;
      viewerImage.dataset.ppMobileActiveIndex = String(activeIndex);

      updateThumbs();
      updateCounter();

      if (shouldScrollThumb && thumbs[activeIndex]) {
        thumbs[activeIndex].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }
    }

    function openActiveMedia() {
      const activeItem = items[activeIndex];
      if (!activeItem || !isViewerActive()) return;
      const opener = activeItem.source.matches && activeItem.source.matches('.product__media-item')
        ? activeItem.source.querySelector('.product__modal-opener, button, a')
        : activeItem.source;
      if (opener && typeof opener.click === 'function') opener.click();
    }

    const initialActiveThumbIndex = thumbs.findIndex((thumb) => thumb.getAttribute('aria-current') === 'true');
    viewer.classList.toggle('pp-mobile-viewer--single', items.length <= 1);
    updateViewer(initialActiveThumbIndex >= 0 ? initialActiveThumbIndex : 0, false);

    thumbs.forEach((thumb, index) => {
      thumb.addEventListener(
        'click',
        (event) => {
          if (!isViewerActive()) return;
          event.preventDefault();
          event.stopPropagation();
          updateViewer(index, true);
        },
        true
      );
    });

    const previous = root.querySelector('[data-pp-mobile-viewer-prev]');
    const next = root.querySelector('[data-pp-mobile-viewer-next]');

    if (previous) {
      previous.addEventListener('click', (event) => {
        event.preventDefault();
        updateViewer(activeIndex - 1, true);
      });
    }

    if (next) {
      next.addEventListener('click', (event) => {
        event.preventDefault();
        updateViewer(activeIndex + 1, true);
      });
    }

    viewerImage.addEventListener('click', openActiveMedia);

    viewer.addEventListener(
      'touchstart',
      (event) => {
        if (!isViewerActive() || !event.touches.length) return;
        touchStartX = event.touches[0].clientX;
        touchStartY = event.touches[0].clientY;
      },
      { passive: true }
    );

    viewer.addEventListener(
      'touchend',
      (event) => {
        if (!isViewerActive() || !event.changedTouches.length) return;
        const touch = event.changedTouches[0];
        const deltaX = touch.clientX - touchStartX;
        const deltaY = touch.clientY - touchStartY;
        if (Math.abs(deltaX) < 48 || Math.abs(deltaX) < Math.abs(deltaY)) return;
        updateViewer(deltaX < 0 ? activeIndex + 1 : activeIndex - 1, true);
      },
      { passive: true }
    );

    root.addEventListener('change', () => {
      window.setTimeout(() => {
        const activeMedia = root.querySelector('.pp-framed-gallery-panel .product__media-item.is-active');
        const activeIndexFromGallery = activeMedia ? thumbs.indexOf(activeMedia) : -1;
        if (activeIndexFromGallery >= 0) updateViewer(activeIndexFromGallery, true);
      }, 180);
    });
  }

  function init() {
    document.querySelectorAll('[data-pp-mobile-gallery-root]').forEach(setupViewer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
